<template>
    <div name="menu">
        메뉴 페이지
        <div @click="gosignup">가입하기</div>
        <div @click="gopreview">미리보기</div>
    </div>
</template>

<script>
export default {
    name: 'menu',
    data: function()
    {
        return {
            timerId: null
        }
    },
    mounted: function()
    {
        //진입시 home으로 이동 카운트 
        this.resetTimeoutCount();

    },
    methods: {
        resetTimeoutCount: function () {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(this.gohome, 20000);
        },
        clearTimer: function()
        {
            clearTimeout(this.timeoutId);
            this.timerId = null;
        },
        gohome: function() {
            this.clearTimer();
            this.$router.push({name: 'home'})
        },
        gosignup: function()
        {
            this.clearTimer();
            this.$router.push({name: 'signup'})
        },
        gopreview: function()
        {
            this.clearTimer();
            this.$router.push({name: 'preview'})
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/page/showcase/Menu.vue